import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table for casino report view.
 */
export default class recordTableCasinoReportView extends JetView {
    /**
     * Configures the datatable for displaying casino report details.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            id: 'tableDetail', // Unique identifier for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: false, // Disable vertical scrolling
            columns: [
                // Column definitions for the datatable
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: _('Detalles'), // Tooltip text
                    template: function (obj) {
                        // Template for rendering the column
                        return "<span class='webix_icon wxi-close details'></span>"; // Icon for details
                    },
                },
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // ID column
                { id: 'Code', header: _('Code'), width: 100, sort: 'int' }, // Code column
                {
                    id: 'TransactionId', // Transaction ID column
                    header: _('Transacción ID'),
                    width: 300,
                    sort: 'int',
                },
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Type column
                {
                    id: 'Amount', // Amount column
                    header: _('Valor'),
                    width: 100,
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number', // Export type for the column
                    sort: 'int',
                },
                {
                    id: 'CreateLocalDate', // Creation date column
                    header: _('Fecha Creación'),
                    width: 150,
                    sort: 'int',
                },
            ],
            onClick: {
                // Event handler for clicking on details icon
                details: function (euv, id) {
                    var item = this.getItem(id); // Get the clicked item
                    this.$scope.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with selected item
                    $$('a5').scrollTo(0, 1000); // Scroll to a specific position
                },
            },
            tooltip: true, // Enable tooltips
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID for pagination
            // API endpoint for fetching data
            url: devConfig.geturlApi() + 'null/Report/GetCasinoGamesReportDetail',
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = grid.data.url; // Store the URL for data fetching
        var filter = ''; // Initialize filter string
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            // Event listener for filtering data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filter values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object filters
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter string
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID
            grid.load(url + '?id=' + idUser); // Load data for specific user
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with selected item
        });
    }
}

// FILE DOCUMENTED
